import Table from "../../components/common/table/Table";
import {
  MESSAGES,
  PRODUCT_GROUP_HEADER_DATA,
  STYLES,
  TABLE_CONFIG,
} from "./productConstants";
import "./productManagement.scss";
import { transformProductGroupsToRowData } from "./productUtils";

const ProductGroupsTable = ({
  productGroups,
  allProducts = [],
  loading,
  onViewGroup,
  onEditGroup,
  onDeleteGroup,
}) => {
  const rowData = transformProductGroupsToRowData(
    productGroups,
    allProducts,
    onViewGroup,
    onEditGroup,
    onDeleteGroup
  );

  if (loading) {
    return <div style={STYLES.loadingContainer}>{MESSAGES.LOADING}</div>;
  }

  return (
    <div className="product-groups-table-container">
      <Table
        headerData={PRODUCT_GROUP_HEADER_DATA}
        rowData={rowData}
        className="product-groups-table"
        pagination={true}
        rowsPerPage={TABLE_CONFIG.ROWS_PER_PAGE}
        noDataLabel="No product groups available"
      />
    </div>
  );
};

export default ProductGroupsTable;
